import ErrorBoundary from "./ErrorBoundary.view";

export default ErrorBoundary;
